"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
function Loading({ noTrans }) {
    return (react_1.default.createElement("div", { className: "loading is-flex is-flex-direction-column is-justify-content-center is-align-items-center p-6" },
        react_1.default.createElement("div", { className: "columns" },
            react_1.default.createElement("div", { className: "column is-12" },
                react_1.default.createElement("div", { className: "custom-loader" }))),
        react_1.default.createElement("h1", { className: "is-size-5 has-text-weight-semibold mb-4" }, noTrans ? "Page loading" : react_1.default.createElement(react_i18next_1.Trans, { i18nKey: "pageLoading" })),
        react_1.default.createElement("p", { className: "has-text-weight-semibold" }, noTrans ? ("Loading content, please wait...") : (react_1.default.createElement(react_i18next_1.Trans, { i18nKey: "loadingContent" })))));
}
exports.default = Loading;
//# sourceMappingURL=Loading.js.map